var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckinwhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7477_40713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7477_40713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4075 9.94283H17.9938C18.1133 12.5327 16.4967 15.9691 13.0071 17.4015C9.55558 18.8188 5.62529 17.7069 3.42495 14.7033C1.23304 11.7115 1.34811 7.59823 3.70056 4.80179C6.20119 1.82965 9.9137 1.23747 12.9964 2.43811C12.5816 2.84843 12.1814 3.25089 11.77 3.64156C11.7262 3.68309 11.6128 3.67636 11.5398 3.6584C8.3802 2.87537 5.27672 4.51271 4.0003 7.37315C2.7424 10.1915 3.8117 13.703 6.43919 15.3595C7.67351 16.138 9.02009 16.5219 10.4666 16.3738C12.8196 16.133 14.5765 14.9435 15.6946 12.8504C16.1723 11.9557 16.4008 10.9885 16.4069 9.94283H16.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11885 13.1152C7.92663 11.9224 6.73048 10.7268 5.5332 9.529C5.89749 9.18323 6.27301 8.82624 6.66649 8.4524C7.44503 9.2461 8.26566 10.083 9.10763 10.9418C11.4618 8.58487 13.7665 6.27677 16.0561 3.98438C16.4333 4.3627 16.7998 4.73092 17.1534 5.08567C14.4878 7.74964 11.8047 10.431 9.11885 13.1152Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckinwhite);
export default __webpack_public_path__ + "static/media/checkinwhite.97455940c7793edc47431c6351c8c614.svg";
export { ForwardRef as ReactComponent };